module.exports = require("./fr-ML.d.ts");